export const CustomerStatusEnum = {
  Inactive: -1,
  NotVerified: 0,
  Plus: 1,
  Basic: 2
}

export default CustomerStatusEnum
